import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "details-block" }
const _hoisted_3 = { class: "details-row details-row--adaptive" }
const _hoisted_4 = { class: "details-value" }
const _hoisted_5 = { class: "details-row details-row--adaptive" }
const _hoisted_6 = { class: "details-value" }
const _hoisted_7 = { class: "details-row details-row--adaptive" }
const _hoisted_8 = { class: "details-value" }
const _hoisted_9 = { class: "details-row details-row--adaptive" }
const _hoisted_10 = { class: "details-value" }
const _hoisted_11 = { class: "details-row details-row--adaptive" }
const _hoisted_12 = { class: "details-value" }
const _hoisted_13 = { class: "details-row details-row--adaptive" }
const _hoisted_14 = { class: "details-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "card-header" }, "Estate Contacts", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "details-label" }, "Developer", -1)),
        _createElementVNode("div", _hoisted_4, _toDisplayString($setup.props.estateContacts.developer), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "details-label" }, "Estate", -1)),
        _createElementVNode("div", _hoisted_6, _toDisplayString($setup.props.estateContacts.estate), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "details-label" }, "Estate address", -1)),
        _createElementVNode("div", _hoisted_8, _toDisplayString($setup.props.estateContacts.address), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "details-label" }, "Contact person", -1)),
        _createElementVNode("div", _hoisted_10, _toDisplayString($setup.props.estateContacts.person), 1)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "details-label" }, "Phone Number", -1)),
        _createElementVNode("div", _hoisted_12, _toDisplayString($setup.props.estateContacts.phone), 1)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "details-label" }, "Email", -1)),
        _createElementVNode("div", _hoisted_14, _toDisplayString($setup.props.estateContacts.email), 1)
      ])
    ])
  ]))
}